import { useAppAccount } from "@/components/AppProvider/AppAccountProvider";
import { useCachedOrganization } from "@/components/InOrganizationProvider/OrganizationProvider";

// aa:user 以上は組織設定に関わらず常に標準表示とする。
export const useIsHeaderOnlyLayout = (): boolean => {
  const { listeningOrganization } = useCachedOrganization();
  const { isAAMemberOrAbove } = useAppAccount();
  if (isAAMemberOrAbove) return false;
  return listeningOrganization
    ? !listeningOrganization.isSidebarEnabled
    : false;
};
